/* app/js/src/components/external-mam/external-mam-providers-setup/external-mam-providers-setup-layout.component.scss */
.cursor-pointer {
  cursor: pointer;
}
.emps-layout .emps-layout-main .emps-layout-current-step::-webkit-scrollbar {
  height: 11px;
  overflow: visible;
  width: 11px;
  opacity: 1;
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
}
.emps-layout .emps-layout-main .emps-layout-current-step::-webkit-scrollbar-button {
  height: 0;
  width: 0;
}
.emps-layout .emps-layout-main .emps-layout-current-step::-webkit-scrollbar-corner {
  background: transparent;
}
.emps-layout .emps-layout-main .emps-layout-current-step::-webkit-scrollbar-thumb:hover {
  background-color: #b9bec9;
}
.emps-layout .emps-layout-main .emps-layout-current-step::-webkit-scrollbar-thumb {
  background-color: #e3e6ea;
  background-clip: padding-box;
  border: solid transparent;
  border-width: 0 4px 0 4px;
  min-height: 28px;
  padding: 100px 0 0;
  border-radius: 10px;
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
}
.emps-layout .emps-layout-main .emps-layout-current-step::-webkit-scrollbar-thumb:hover {
  background-color: #b9bec9;
}
.emps-layout .emps-layout-main .emps-layout-current-step::-webkit-scrollbar-track:hover {
  background-color: #eef2f6;
}
.emps-layout .emps-layout-main .emps-layout-current-step::-webkit-scrollbar-track {
  background-clip: padding-box;
  border: solid transparent;
  border-width: 0 4px 0 4px;
}
:host {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 30px;
}
.emps-title {
  color: rgba(0, 0, 0, 0.85);
  text-align: center;
  font-family: Open Sans;
  font-size: 24px;
  font-style: normal;
  font-weight: 700;
  line-height: 36px;
  align-self: stretch;
}
.emps-layout {
  display: flex;
  align-items: flex-start;
  border-radius: 4px;
  background: #ffffff;
  height: 70vh;
}
.emps-layout .emps-layout-aside {
  width: 300px;
  padding: 25px;
  display: flex;
}
.emps-layout .emps-layout-main {
  display: flex;
  width: 960px;
  max-width: 960px;
  align-items: center;
  flex-direction: column;
  gap: 20px;
  border-left: 1px solid rgba(0, 0, 0, 0.1);
  max-height: 70vh;
  height: 70vh;
}
.emps-layout .emps-layout-main .emps-layout-current-step {
  height: 70vh;
  overflow: auto;
  overflow-x: hidden;
  padding: 25px 25px;
  width: 100%;
}
.emps-layout .emps-layout-main .emps-layout-buttons {
  display: flex;
  padding: 20px;
  justify-content: space-between;
  align-items: flex-start;
  align-self: stretch;
}
.emps-layout .emps-layout-main .emps-layout-buttons .emps-layout-button {
  color: rgba(0, 0, 0, 0.54);
  border-radius: 4px;
  border: 1px solid rgba(0, 0, 0, 0.14);
  display: flex;
  padding: 9px 16px 9px 9px;
  align-items: flex-end;
  gap: 8px;
  background-color: transparent;
}
.emps-layout .emps-layout-main .emps-layout-buttons .emps-layout-button:hover,
.emps-layout .emps-layout-main .emps-layout-buttons .emps-layout-button:active {
  color: rgb(255, 255, 255);
  border-color: #2dbbfc;
  background-color: #2dbbfc;
}
.emps-layout .emps-layout-main .emps-layout-buttons .emps-layout-button:only-child {
  margin-left: auto;
}
.emps-layout .emps-layout-main .emps-layout-buttons .emps-layout-button span {
  text-align: center;
  font-feature-settings: "clig" off, "liga" off;
  font-family: Open Sans;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 24px;
  text-transform: uppercase;
}
/*# sourceMappingURL=external-mam-providers-setup-layout.component.css.map */
